//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'star-pic-list',
  props: ['data'],
  data() {
    return {
      centerDialogVisible: false,
      showPic: '',
      isDialogShow: false,
      index: 0
    }
  },
  computed: {
    images() {
      return this.data
    }
  },
  methods: {
    // 放大图片
    enlargePic(e) {
      this.isDialogShow = true
      this.centerDialogVisible = true
      this.showPic = this.data[0]
      console.log(this.images)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PictureList.vue